import { Component } from '@angular/core';
import { SpinnerService } from '../../services/spinner-service';

@Component({
  selector: 'app-auth-callback',
  imports: [],
  templateUrl: './auth-callback.html',
  styleUrl: './auth-callback.scss',
})
export class AuthCallback {
  constructor(private spinnerService: SpinnerService) {}
  ngOnInit() {
    this.spinnerService.show();
  }
  ngOnDestroy() {
    this.spinnerService.hide();
  }
}
